import { CONVERSATIONS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(CONVERSATIONS_ENDPOINT);
export default instance;
